import React, {useEffect, useState} from 'react';

import './FullEvent.scss';
import EventsApi from "../../../api/EventsApi";
import {Link} from "react-router-dom";
import * as actionCreators from "../../../store/actions/actions";
import {connect} from "react-redux";
import {useParams, Navigate} from "react-router-dom";
import DateDecorated from "../../../components/DateDecorated/DateDecorated";
import moment from 'moment';
import {useNavigate} from "react-router";
import Album from "../../../components/Album/Album";
import YouTubeWidget from "../../../components/YouTube/YouTubeWidget";
import {getAlbumPath, youtubeParser} from "../../../tools/formatter";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';

function FullEvent(props) {

    const navigate = useNavigate();
    const { eventId } = useParams();
    const [isDeleted, setIsDeleted] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [youtubeUrl, setYoutubeUrl] = useState('');
    const [invalidYoutubeUrls, setInvalidYoutubeUrls] = useState([]);
    const onGetEvent = props.onGetEvent;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        const urls = youtubeUrl
            .split(/\r?\n/)
            .map(url => url.trim())
            .filter(url => url);

        const invalidUrls = [];
        const newVideoCodes = [];

        urls.forEach(url => {
            const youtubeCode = youtubeParser(url);
            if (youtubeCode) {
                newVideoCodes.push(youtubeCode);
            } else {
                invalidUrls.push(url);
            }
        });

        setInvalidYoutubeUrls(invalidUrls);

        if (newVideoCodes.length) {
            const currentVideo = props.currentEvent.video;
            let existingVideoCodes = [];

            if (currentVideo) {
                existingVideoCodes = currentVideo
                    .split(',')
                    .map(video => video.trim())
                    .filter(video => video);
            }

            const videos = Array.from(new Set([
                ...existingVideoCodes,
                ...newVideoCodes
            ]));

            const updatedEvent = {
                ...props.currentEvent,
                video: videos.join(',')
            };

            EventsApi.updateEvent(updatedEvent).then(response => {
                window.location.reload();
            }).catch(error => {
                //TODO catch
            });
        }

        setYoutubeUrl('');
        setOpen(false);
    };

    const deleteVideo = (video) => {
        if (video) {
            const currentVideo = props.currentEvent.video;
            let videos = [];
            if (currentVideo) {
                videos = currentVideo.split(',');
            }
            const newVideos = videos.filter(v => v !== video)
            const updatedEvent = {
                ...props.currentEvent,
                video: newVideos.join(',')
            };
            EventsApi.updateEvent(updatedEvent).then(response => {
                window.location.reload();
            }).catch(error => {
                //TODO catch
            })
        } else {
            alert('Incorrect input');
        }
    };

    const handleYoutubeUrlChange = (event) => {
        setYoutubeUrl(event.target.value);
    };

    useEffect(() => {
        console.log('componentdidmount');
        if ( eventId ) {
            EventsApi.getEvent(eventId).then(response => {
                onGetEvent(response.event);
            } ).catch(error => {
                //TODO catch
            });
        }
        return () => {
            console.log('DESCTRUCTOR FULL EVENT');
        }
    }, [eventId, onGetEvent]);

    useEffect(() => {
        if (props.currentEvent && eventId === props.currentEvent.id) {
            setIsLoaded(true);
        }
    }, [props.currentEvent, eventId]);

    const deleteDataHandler = () => {
        EventsApi.deleteEvent(props.currentEvent.id).then(response => {
            setIsDeleted(true);
        }).catch(error => {
            //TODO catch
        })
    }

    const cancelHandler = () => {
        navigate('/');
    }

    let eevent = <p style={{ textAlign: 'center' }}>Loading...</p>;
    if(isDeleted) {
        eevent = <Navigate to="/" />;
    } else if ( props.currentEvent && isLoaded) {
        eevent = (
            <div className={"event-block"}>
                <div className={"details-block"}>
                    <DateDecorated date={moment(props.currentEvent.date)} />
                    <div className={"event-title-block"}>
                        <p className="event-title">{props.currentEvent.title}</p>
                        <div className={"buttons-block"}>
                            <img className={"img-btn"} alt={"Add youtube"} src={"/youtube.png"} onClick={handleClickOpen}></img>
                            <Link to={'/my-events/update/' + props.currentEvent.id}>
                                <img className={"img-btn"} src={"/edit.png"} alt={"Edit event"} />
                            </Link>
                            <img  className={"img-btn"} alt={"Delete"} src={"/trash.png"} onClick={deleteDataHandler}></img>
                            <img  className={"img-btn"} alt={"Back"} src={"/back.png"} onClick={cancelHandler}></img>
                        </div>
                    </div>
                    {props.currentEvent.description && <p className="event-description">{props.currentEvent.description}</p>}
                </div>
                {invalidYoutubeUrls.length > 0 && (
                    <Alert severity="warning">
                        Unable to extract YouTube video code from:
                        <ul>
                            {invalidYoutubeUrls.map(url => (
                                <li key={url}>{url}</li>
                            ))}
                        </ul>
                    </Alert>
                )}
                <div className={"album-block"} >
                    <Album eventIsLoaded={isLoaded} path={getAlbumPath(props.currentEvent)} currentEvent={props.currentEvent}/>
                </div>
                {props.currentEvent.video && <div>
                    {props.currentEvent.video.split(',').map(video => {
                        return <div className={"video"}>
                            <YouTubeWidget key={video} embedId={video} />
                            <img alt={"Delete"} src={"/delete.png"} onClick={()=> {
                                deleteVideo(video);
                            }}></img>
                        </div>
                    })}
                </div>}
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Add Youtube Video</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please add Youtube URLs of your videos, each one on its own line
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="youtubevideo"
                            label="Youtube URLs"
                            type="text"
                            fullWidth
                            multiline
                            minRows={4}
                            variant="standard"
                            value={youtubeUrl}
                            onChange={handleYoutubeUrlChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={handleSubmit}>Add</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    return eevent;

}

const mapStateToProps = state => {
    return {
        currentEvent: state.eventsData.currentEvent
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetEvent: (currentEvent) => dispatch(actionCreators.getEvent(currentEvent)),
        onDeleteEvent: (eventId) => dispatch(actionCreators.deleteEvent(eventId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FullEvent);